// extracted by mini-css-extract-plugin
export default {"main":"Main_main__uAfc3","link":"Main_link__eJCGQ","wrapper":"Main_wrapper__U+I35"};